import type { FC, ReactNode } from "react";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import { AppLogo } from "./AppLogo.tsx";
import { AppNavButton } from "./AppNavButton.tsx";

interface NavigationItem {
  readonly label: string;
  readonly path: string;
}

interface AppHeaderProps {
  readonly items?: readonly NavigationItem[];
  readonly rightContent?: ReactNode;
  readonly title: string;
}

export const AppHeader: FC<AppHeaderProps> = ({
  items = [],
  rightContent,
  title,
}) => {
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-header-border bg-linear-to-b from-header-from to-header-to">
      <div
        className={`
          flex h-12 items-center justify-between px-4
          lg:px-6
        `}
      >
        <div className="flex items-center gap-6">
          <AppLogo title={title} />
          <nav
            className={`
              hidden items-center gap-1
              md:flex
            `}
          >
            {items.map(item => (
              <AppNavButton
                active={item.path === location.pathname}
                asChild
                key={item.path}
              >
                <Link to={item.path}>{item.label}</Link>
              </AppNavButton>
            ))}
          </nav>
        </div>
        {rightContent}
      </div>
    </header>
  );
};
